export default __webpack_public_path__ + "static/greaves-dbb5c0f3f19b04d949457963687c9681.jpg";